module.exports = __webpack_public_path__ + "static/media/aladdins-treasure.bc88794f.gif";